<template>
  <ModalContainer
    v-for="[modalId, { forceFullscreen }] of modals.entries()"
    :key="modalId"
    :id="modalId"
    :force-fullscreen="forceFullscreen"
  />
</template>

<script setup lang="ts">
import { useModalStore } from '@/stores/modal'
import ModalContainer from './ModalContainer.vue'
const { modals } = useModalStore()
</script>
